import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { acknowledgeNotification, fetchNotifications } from '../../lib/api';
import OperatorInbox from './OperatorInbox';

export default function NotificationBell() {
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const loadCount = useCallback(async () => {
    const res = await fetchNotifications(true);
    if (res.ok && res.data) {
      setUnread(res.data.unreadCount);
    }
  }, []);

  useEffect(() => {
    void loadCount();
    const interval = setInterval(() => void loadCount(), 30000);
    return () => clearInterval(interval);
  }, [loadCount, refreshKey]);

  const handleAck = async (id: string) => {
    await acknowledgeNotification(id);
    setRefreshKey((k) => k + 1);
    void loadCount();
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="relative rounded p-2 text-zt-muted hover:bg-zt-elevated hover:text-slate-200"
        aria-label="Notifications"
      >
        {unread > 0 && (
          <span className="absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-zt-danger px-1 text-[10px] font-bold text-white ring-2 ring-zt-surface">
            {unread > 9 ? '9+' : unread}
          </span>
        )}
        <Bell size={20} />
      </button>
      {open && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-40"
            aria-label="Close notifications"
            onClick={() => setOpen(false)}
          />
          <div className="absolute right-0 top-full z-50 mt-2 w-96 max-h-[70vh] overflow-hidden rounded-lg border border-zt-border bg-zt-elevated shadow-xl">
            <div className="flex items-center justify-between border-b border-zt-border px-3 py-2">
              <span className="text-xs font-medium text-slate-200">Notifications</span>
              <Link
                to="/ai?rail=inbox"
                className="text-[11px] text-zt-primary hover:underline"
                onClick={() => setOpen(false)}
              >
                Open in AI
              </Link>
            </div>
            <OperatorInbox compact onAck={handleAck} refreshKey={refreshKey} />
          </div>
        </>
      )}
    </div>
  );
}
